import { changeLog } from "@/mocks/content";
import SectionHeading from "./SectionHeading";

export default function LogSection() {
  return (
    <section id="log" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <SectionHeading
          eyebrow="地址更新记录"
          title="每一次调整都留档，方便你核对"
          desc="地址发生变更后，本页会按批次记录下来。回访时对照日期，就能知道手上的地址是否还是最新的。"
        />

        <div className="relative pl-6 md:pl-8">
          <span className="absolute left-[7px] md:left-[11px] top-2 bottom-2 w-px bg-background-300"></span>
          <div className="flex flex-col gap-5">
            {changeLog.map((log, i) => (
              <article key={log.id} className="relative">
                <span
                  className={`absolute -left-6 md:-left-8 top-1.5 w-4 h-4 rounded-full border-2 border-background-50 ${
                    i === 0 ? "bg-primary-500" : "bg-background-400"
                  }`}
                ></span>
                <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
                  <div className="flex flex-wrap items-center gap-3 mb-3">
                    <span className="font-heading font-semibold text-foreground-950">{log.date}</span>
                    <span className="text-xs text-foreground-500">{log.version}</span>
                    <span
                      className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${
                        log.tag === "最新" ? "bg-primary-100 text-primary-700" : "bg-secondary-100 text-secondary-900"
                      }`}
                    >
                      {log.tag}
                    </span>
                  </div>
                  <ul className="flex flex-col gap-2">
                    {log.items.map((item) => (
                      <li key={item} className="flex items-start gap-2 text-sm text-foreground-700 leading-relaxed">
                        <i className="ri-checkbox-circle-line text-accent-600 mt-0.5"></i>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            ))}
          </div>
        </div>

        <div className="mt-8 rounded-lg border border-background-200 bg-background-100 p-4 md:p-5 flex items-start gap-3">
          <i className="ri-history-line text-primary-600 text-lg mt-0.5"></i>
          <p className="text-sm text-foreground-600 leading-relaxed">
            以上为近期地址调整的公开记录。若你保存的地址不在最近批次内，建议以本页展示的最新入口为准。
          </p>
        </div>
      </div>
    </section>
  );
}